import s from "./index270.js";
import { resolveComponent as a, createBlock as t, openBlock as r, createSlots as d, withCtx as i, renderSlot as u } from "vue";
import m from "./index231.js";
function p(o, e, c, g, h, f) {
  const n = a("cs-autocomplete-dropdown");
  return r(), t(n, {
    modelValue: o.modelValue,
    "onUpdate:modelValue": [
      e[0] || (e[0] = (l) => o.modelValue = l),
      o.onModelUpdate
    ],
    placeholder: o.placeholder,
    autoFocus: o.autoFocus,
    suggestions: o.suggestions,
    "data-component": o.$options.name,
    label: o.computedLabel,
    errorMsg: o.errorMsg,
    isInactive: o.isInactive,
    showImmediately: o.hasGermanyFallback,
    onHighlighted: o.onHighlighted,
    onSelect: o.onSelect,
    onFocus: o.onFocus,
    onBlur: o.onBlur
  }, d({ _: 2 }, [
    o.$slots.icon ? {
      name: "icon",
      fn: i(() => [
        u(o.$slots, "icon")
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["modelValue", "placeholder", "autoFocus", "suggestions", "data-component", "label", "errorMsg", "isInactive", "showImmediately", "onHighlighted", "onSelect", "onUpdate:modelValue", "onFocus", "onBlur"]);
}
const w = /* @__PURE__ */ m(s, [["render", p]]);
export {
  w as default
};
